<template>
  <el-container class="login_bg" type="flex" style="height:100%">
    <el-main>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="total">
        <div class="item">
          <i class="icon el-icon-document"></i>
          <div class="info">
            <div class="num">200</div>
            <div class="describe">今日订单</div>
          </div>
        </div>
        <div class="item">
          <i class="icon el-icon-s-custom"></i>
          <div class="info">
            <div class="num">200</div>
            <div class="describe">当日客户新增数量</div>
          </div>
        </div>
        <div class="item">
          <i class="icon el-icon-document-checked"></i>
          <div class="info">
            <div class="num">200</div>
            <div class="describe">今年成交金额</div>
          </div>
        </div>
        <div class="item">
          <i class="icon el-icon-sell"></i>
          <div class="info">
            <div class="num">200</div>
            <div class="describe">商品总数</div>
          </div>
        </div>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="title">销量总排行</div>
          <el-card class="box-card">
            <!-- <div class="date_time">日期：
            <el-date-picker size="mini" v-model="dataValue" type="daterange" :picker-options="pickerOptions"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
              align="right" @change="changeDatePicker">
            </el-date-picker>
          </div> -->
            <div id="conversion_rate" style="min-width: 400px;max-width: 800px;height:300px;"></div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <div class="title">
            库存预警
          </div>
          <el-card>
            <router-link to="/home/index" style="text-decoration: none;">
              <el-alert title="" type="info" show-icon :closable="false">
                XX商品（SP00001）不足，请进行采购 <span class="date">2022-12-2 9:01:10</span>
              </el-alert>
            </router-link>
            <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
              :current-page="formInline.page" :page-sizes="formInline.pageSize" layout="total, prev, pager, next"
              :total="total" hide-on-single-page>
            </el-pagination>
          </el-card>
        </el-col>
      </el-row>
    </el-main>

    <div class="footer-copyright">Copyright@2016-2023杭州闪派网络科技有限公司版权所有 网站备案/许可证号：
      <a href="https://beian.miit.gov.cn/" target="“_blank&quot;">浙ICP备16031137号</a>
      <img :src="require('@/assets/images/gongan.png')" alt="" style="vertical-align: middle;margin-left: 10px;"> 浙公网安备案
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007569"
        target="“_blank&quot;">33010502007569</a>
    </div>
  </el-container>
</template>
<script>
import {
  mapState
} from 'vuex'
import * as echarts from 'echarts';
export default {
  name: "CompanyWelcome",
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dataValue: [],
      start_dt: '',
      end_dt: '',
      formInline: {
        keywords: '',
        dataValue: [],
        start_dt: '',
        end_dt: '',
        page: 1,
        pageSize: 10
      },
      total: 100,
      invoiceList: [],

    }
  },
  mounted() {
    var conversionRateChart = echarts.init(document.getElementById('conversion_rate'));
    var option = {
      color: ['#ffd04b'],
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
      },
      yAxis: {
        type: 'value'
      },
      series: [{
        data: [0, 820],
        type: 'line',
        areaStyle: {}
      }]
    };
    conversionRateChart.setOption(option);
  },
  methods: {
    onSearch() {
      this.formInline.page = 1
      this.getTableDate();
    },
    handleCurrentChange(val) {
      this.formInline.page = val
      this.getTableDate();
    },
    changeDatePicker(val) {
      if (val) {
        this.formInline.start_dt = val[0]
        this.formInline.end_dt = val[1]
      } else {
        this.formInline.start_dt = ''
        this.formInline.end_dt = ''
      }
    },
  },
  computed: {
    ...mapState({
      indexPath: state => state.indexPath
    }),
  },
}
</script>
<style scoped lang="scss">
.el-container {
  flex-direction: column;

  .footer-copyright {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
  }
}

.el-breadcrumb {
  margin-bottom: 15px;
}

.total {
  display: flex;
  justify-content: space-between;

  .item {
    display: flex;

    .info {
      display: flex;
      flex-direction: column;
      font-size: 20px;
      color: #606266;
      justify-content: space-around;

      .num {
        font-weight: 600;
      }
    }

  }

  .icon {
    font-size: 100px;
    color: #ffd04b;
  }
}

.title {
  font-size: 20px;
  font-weight: 600;
  color: #606266;
  margin: 20px 0;
}

.el-card {
  /deep/ .el-alert__content {
    width: 100%;
  }

  /deep/ .el-alert__description {
    margin-top: 0;
    position: relative;

    .date {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}

.sales_volume {
  margin-bottom: 20px;

  .el-row {
    margin-bottom: 15px;
  }

  .el-row:last-child {
    margin-bottom: 0;
  }
}
</style>